import React, { useState } from "react";
import { pos_configuration_test_connection } from "../../../../store/actions/SuperAdminActions/adminPosconfigurationAdd";
import { Button } from "react-bootstrap";
import { serverApi } from "../../../../config/Keys";
import axios from "axios";
import Alert from "react-s-alert";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Alert as AlertMaterialUI } from "@material-ui/lab";

function TestConnection(props) {
  const token = localStorage.getItem("userData");

  const onSuccess = (data) => {
    if (props?.onSuccess) {
      props.onSuccess(data);
    }
  };

  const testConnection = async (values) => {
    try {
      let response = await axios.post(
        `${serverApi}/pos/api/PET_POOJA/testConnection`,
        {
          ...props?.formData,
          ...values,
          pos_config_id: props?.data?.pos_config_id?._id,
        },
        {
          headers: {
            Authorization: token.accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      setIsOpen(false);
      if (response.data.success === "1") {
        Alert.success(`<h4> Active Connection</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
      } else {
        Alert.error(`<h4>${response.data.message}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccess(response.data.message);
    } catch (err) {
      console.log(err, "errorrrrr");
      // Alert.error(`<h4>${response.data.message}</h4>`, {
      //   position: "top-right",
      //   effect: "bouncyflip",
      //   beep: true,
      //   html: true,
      //   timeout: 3000,
      //   offset: 35,
      // });
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const formik = useFormik({
    initialValues: {
      restaurantId: "",
      itemSharingCode: "",
    },
    validationSchema: Yup.object({
      restaurantId: Yup.string().required("Required"),
      itemSharingCode: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      // onSubmit(values);
      // formik.resetForm();
      testConnection(values);
    },
  });
  const onRequestClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div>
        <Dialog
          open={isOpen}
          onClose={onRequestClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            Test connection{" "}
            {props?.data && `for ${props?.data?.pos_config_id?.title || ""}`}
          </DialogTitle>
          <DialogContent className="transparentBackground">
            <TextField
              fullWidth
              id="restaurantId"
              name="restaurantId"
              label="Restaurant ID"
              variant="outlined"
              className="transparentBackground"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.restaurantId}
              error={
                formik.touched.restaurantId && !!formik.errors.restaurantId
              }
              helperText={
                formik.touched.restaurantId && formik.errors.restaurantId
              }
            />
            <br />
            <br />
            <TextField
              fullWidth
              id="itemSharingCode"
              name="itemSharingCode"
              label="Item Sharing Code"
              variant="outlined"
              className="transparentBackground"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.itemSharingCode}
              error={
                formik.touched.itemSharingCode &&
                !!formik.errors.itemSharingCode
              }
              helperText={
                formik.touched.itemSharingCode && formik.errors.itemSharingCode
              }
            />
            <br />
            <br />
            <AlertMaterialUI color="warning">
              Please check the point of sale dashboard to get the data.
            </AlertMaterialUI>

            <br />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={formik.handleSubmit}
              variant="danger"
              className="px-5"
              autoFocus
            >
              Test
            </Button>
          </DialogActions>
        </Dialog>
        <Button
          variant="danger"
          className="btn-sm px-5 btn150px"
          onClick={() => setIsOpen(true)}
        >
          {" "}
          Test connection
        </Button>
      </div>
    </>
  );
}

export default TestConnection;
